'use client';

import Quote from '@/components/typography/quote';
import { useTranslation } from 'react-i18next';

export default function Hero() {
    const { t } = useTranslation();

    return (
        <div className="mt-[7rem] mb-[4.5rem] max-w-[1278px] p-4 text-center lg:mx-auto lg:mt-[10rem]">
            <Quote className="inline">{t('hero')} </Quote>
        </div>
    );
}
